var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "csup-page" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "csup-links" }, [
      _c(
        "a",
        { staticClass: "csup-link-card", attrs: { href: _vm.mailtoHref } },
        [
          _c("span", {
            staticClass: "csup-link-card__icon dashicons dashicons-email-alt"
          }),
          _vm._v(" "),
          _vm._m(1)
        ]
      ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "csup-columns" }, [
      _c(
        "div",
        { staticClass: "csup-card csup-card--faq" },
        [
          _c("h2", { staticClass: "csup-card__title" }, [
            _vm._v("Frequently Asked Questions")
          ]),
          _vm._v(" "),
          _c(
            "el-collapse",
            {
              attrs: { accordion: "" },
              model: {
                value: _vm.openFaq,
                callback: function($$v) {
                  _vm.openFaq = $$v
                },
                expression: "openFaq"
              }
            },
            _vm._l(_vm.faqs, function(item, index) {
              return _c(
                "el-collapse-item",
                { key: index, attrs: { name: index, title: item.q } },
                [
                  _c("p", { staticClass: "csup-faq__answer" }, [
                    _vm._v(_vm._s(item.a))
                  ])
                ]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "csup-card csup-card--info" }, [
        _c(
          "div",
          { staticClass: "csup-card__head" },
          [
            _c("h2", { staticClass: "csup-card__title" }, [
              _vm._v("System Information")
            ]),
            _vm._v(" "),
            _c(
              "el-tooltip",
              { attrs: { content: "Copy to clipboard", placement: "top" } },
              [
                _c(
                  "button",
                  { staticClass: "csup-copy-btn", on: { click: _vm.copyInfo } },
                  [_c("span", { staticClass: "dashicons dashicons-clipboard" })]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { staticClass: "csup-hint" }, [
          _vm._v("Include this when contacting support.")
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "csup-info-table" }, [
          _c(
            "tbody",
            _vm._l(_vm.infoRows, function(row) {
              return _c("tr", { key: row.label }, [
                _c("td", { staticClass: "csup-info-table__label" }, [
                  _vm._v(_vm._s(row.label))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "csup-info-table__value" }, [
                  _vm._v(_vm._s(row.value))
                ])
              ])
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "csup-header" }, [
      _c("div", { staticClass: "csup-header__icon" }, [
        _c("span", { staticClass: "dashicons dashicons-sos" })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h1", { staticClass: "csup-header__title" }, [
          _vm._v("Help & Support")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "csup-header__sub" }, [
          _vm._v("Find answers, check your environment, or get in touch")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("strong", [_vm._v("Contact Support")]),
      _vm._v(" "),
      _c("span", [_vm._v("Email the site administrator")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "csup-link-card",
        attrs: { target: "_blank", href: "https://wpcontactum.com/docs/" }
      },
      [
        _c("span", {
          staticClass: "csup-link-card__icon dashicons dashicons-book"
        }),
        _vm._v(" "),
        _c("div", [
          _c("strong", [_vm._v("Documentation")]),
          _vm._v(" "),
          _c("span", [_vm._v("Guides for building forms & payments")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "csup-link-card",
        attrs: {
          target: "_blank",
          href: "https://www.youtube.com/@wpspicy-hh8tn"
        }
      },
      [
        _c("span", {
          staticClass: "csup-link-card__icon dashicons dashicons-video-alt3"
        }),
        _vm._v(" "),
        _c("div", [
          _c("strong", [_vm._v("Video Tutorials")]),
          _vm._v(" "),
          _c("span", [_vm._v("Step-by-step walkthroughs")])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }